export default "__VITE_ASSET__BNKak5sj__"